import React from 'react';
import PropTypes from 'prop-types';
import { ConditionalLink } from '@plone/volto/components';
import { Image } from 'semantic-ui-react';
import FadeInSection from '../../../theme/Animations/FadeInSection';
import { flattenToAppURL } from '@plone/volto/helpers';
import { useSelector } from 'react-redux';

const ProjektKategorieListing = ({ items, isEditMode }) => {
  const getColorClass = (index) => {
    if (index % 4 === 0) return 'dunkelblau';
    if (index % 3 === 0) return 'hellblau';
    if (index % 2 === 0) return 'blau';
    return 'grün';
  };

  const t = {
    de: {
      button: "Mehr erfahren",
    },
    en: {
      button: "Learn more",
    },
  };

  const currentLang = useSelector((state) => state.intl.locale);
  const text = t[currentLang] || t.de;

  return (
    <section className="projekt-kategory-listing" aria-label="Projektkategorien" role="list">
      <div className="ui twelve column grid column-grid">
        {items.map((item, index) => (
          <article
            key={index}
            className="six wide computer twelve wide mobile six wide tablet column column-blocks-wrapper"
            role="listitem"
            aria-labelledby={`projekt-title-${index}`}
          >
            <FadeInSection>

              <ConditionalLink item={item} condition={!isEditMode}>
                <div
                  className={`listing-kachel ${getColorClass(index)}`}
                  role="article"
                  aria-label={`Projekt: ${item.title}`}
                  tabIndex={!isEditMode ? 0 : undefined}
                >
                  {item.image_scales?.preview_image?.[0]?.download && (
                    <Image
                      src={flattenToAppURL(item['@id'] + '/' + item.image_scales.preview_image[0].download)}
                      alt={item.alt || item.title || ''}
                      aria-hidden={!(item.alt || item.title)}
                    />
                  )}

                  {!item.image_scales && item.preview_image?.download && (
                    <Image
                      src={flattenToAppURL(item.preview_image.download)}
                      alt={item.alt || item.title || ''}
                      aria-hidden={!(item.alt || item.title)}
                    />
                  )}

                  <h2 id={`projekt-title-${index}`}>{item.title}</h2>

                  <div className="pretty">
                    <button>{text.button}</button>
                  </div>
                </div>
              </ConditionalLink>
            </FadeInSection>

          </article>
        ))}
      </div>
    </section>
  );
};

ProjektKategorieListing.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  isEditMode: PropTypes.bool,
};

export default ProjektKategorieListing;